Drupal.behaviors.sub_menu_mobile = {
  attach: function (context, settings) {
   'use strict';

   // Set 'document' to 'context' if Drupal
   var mobileLinkExpand = context.querySelectorAll('.main-sub-menu_mobile__item--with-sub > .expand-sub');

   // Accordion Toggle
   // Mobile Click Menu Transition
   for (var i = 0; i < mobileLinkExpand.length; i++) {
     mobileLinkExpand[i].addEventListener('click', function (e) {
       var className = 'main-sub-menu_mobile__item--active';
       // Add is-active class
       if (this.parentNode.classList) {
         this.parentNode.classList.toggle(className);
       }
       else {
         var classes = this.parentNode.className.split(' ');
         var existingIndex = classes.indexOf(className);

         if (existingIndex >= 0) {
           classes.splice(existingIndex, 1);
         }
         else {
           classes.push(className);
         }
         this.parentNode.className = classes.join(' ');
       }
       e.preventDefault();
     });
   }

 }
};
